import { render, staticRenderFns } from "./salesperson.vue?vue&type=template&id=5e4c2278&scoped=true"
import script from "./salesperson.vue?vue&type=script&lang=js"
export * from "./salesperson.vue?vue&type=script&lang=js"
import style0 from "./salesperson.vue?vue&type=style&index=0&id=5e4c2278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4c2278",
  null
  
)

export default component.exports